$(function () {
    $('.collapse').on('show.bs.collapse', function () {
        $(this).parent().removeClass('collapsed');
    });

    $('.collapse').on('hide.bs.collapse', function () {
        $(this).parent().addClass('collapsed');
    });
});